import React, { useState, useEffect } from 'react';
import { SessionReplacedModal } from './SessionReplacedModal';
import { socketService } from '../services/socketService';

export const AppWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [showSessionReplacedModal, setShowSessionReplacedModal] = useState(false);
  const [deviceInfo, setDeviceInfo] = useState<string>();

  useEffect(() => {
    // Escuchar evento de sesión reemplazada desde socketService
    const handleSessionReplaced = (data: any) => {
      console.log('🚨 Mostrando modal de sesión reemplazada');
      setDeviceInfo(data.device || 'otro dispositivo');
      setShowSessionReplacedModal(true);
    };

    // Suscribirse al evento
    socketService.on('session:replaced', handleSessionReplaced);

    // Limpiar suscripción al desmontar
    return () => {
      socketService.off('session:replaced', handleSessionReplaced);
    };
  }, []);

  return (
    <>
      {children}
      <SessionReplacedModal
        isOpen={showSessionReplacedModal}
        device={deviceInfo}
      />
    </>
  );
};
